// extracted by mini-css-extract-plugin
export default {"circle":"LoadingCurl_circle__YnDfw","xs":"LoadingCurl_xs__rAH9J"};